// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wheeldiv[data-v-5be9b308]{display:grid;grid-template-columns:1fr 1fr 1fr;grid-template-rows:1fr 1fr 1fr;text-align:center;margin:5px}.checkbox[data-v-5be9b308]{height:13px;width:13px}p[data-v-5be9b308]{margin:0}", ""]);
// Exports
module.exports = exports;
